import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { GiveawayGoodieSteps } from 'swag-common/interfaces';
import { checkIsGiveawayWithSwagType, checkIsGiveawayWithGoodieType } from 'swag-common/utils/giveaway/giveaway-type.util';
import { GiveawayLandingComponent } from '../../partials/giveaway-landing/giveaway-landing';
import { submitGiveawayLink } from '../../../redux/giveaway-landing/giveaway-landing.actions';
import { giveawayLinkItemItemSelector, giveawayTypeLabelLandingSelector, isCurrentGiveawayLandingSubmitButtonDisabledSelector, selectedGiveawayColorWithFallbackSelector, selectedGiveawaySelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { isImagesInLoadingSelector } from '../../../redux/image-loading/image-loading.selectors';
import { pathnameSelector } from '../../../redux/routing/routing.selectors';
import { showLoadingOverlaySelector } from '../../../redux/common/common.selectors';
const goodieGiveawayStepSelector = createSelector(pathnameSelector, selectedGiveawaySelector, (pathname, giveaway) => {
  if (!giveaway || checkIsGiveawayWithSwagType(giveaway)) {
    return null;
  }
  const isGoodieGiveaway = checkIsGiveawayWithGoodieType(giveaway);
  const isCheckout = pathname.includes(GiveawayGoodieSteps.checkout);
  if (isGoodieGiveaway) {
    if (isCheckout) {
      return GiveawayGoodieSteps.checkout;
    }
    return GiveawayGoodieSteps.catalog;
  }
  return null;
});
const mapStateToProps = () => {
  return createStructuredSelector({
    giveaway: selectedGiveawaySelector,
    isImagesInLoading: isImagesInLoadingSelector,
    disabled: isCurrentGiveawayLandingSubmitButtonDisabledSelector,
    step: goodieGiveawayStepSelector,
    link: giveawayLinkItemItemSelector,
    giveawayTypeLabel: giveawayTypeLabelLandingSelector,
    isLoading: showLoadingOverlaySelector,
    submitButtonColor: selectedGiveawayColorWithFallbackSelector
  });
};
const mapDispatchToProps = dispatch => bindActionCreators({
  onSubmit: submitGiveawayLink
}, dispatch);
const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(GiveawayLandingComponent);
export const GiveawayLandingClient = connectedComponent;